import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'

class MeetingStatusSection extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { meeting_time, accepted, requestor, requestee, status } = this.props.item
    const now = moment()
    const meetingTime = moment(meeting_time)

    if ((status === "Canceled" || status === "Cancelled") || (now.isAfter(meetingTime) && accepted != true) ) {
      return(
        <div style={{textAlign: 'left'}}>
          <h6 className="meetingStatus red">CANCELLED</h6>
        </div>
      )
    } else if (now.isAfter(meetingTime)) {

      return(
        <div style={{textAlign: 'left'}}>
          <h6 className="meetingStatus">COMPLETE</h6>
        </div>
      )
    }
    else if(accepted === false) {
      if(requestor.id === this.props.currentUser.id) {
        return(
          <div style={{textAlign: 'left'}}>
            <h6 className="meetingStatus red">WAITING FOR {(this.props.item.requestee.nickname != undefined && this.props.item.requestee.nickname.length > 1 ) ? `${this.props.item.requestee.nickname.toUpperCase()}'` : `${this.props.item.requestee.first_name.toUpperCase()}'`}S APPROVAL</h6>
          </div>
        )
      } else {
        return(
          <div style={{textAlign: 'left'}}>
            <h6 className="meetingStatus red">NEEDS YOUR RESPONSE</h6>
          </div>
        )
      }
    } else {
      return null
    }
  }
}

export default MeetingStatusSection;
